"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readStripeChangePaymentMethodDetails = readStripeChangePaymentMethodDetails;
exports.buildStripeChangePaymentMethodReturnUrl = buildStripeChangePaymentMethodReturnUrl;
exports.getStripePublicKey = getStripePublicKey;
exports.createStripeChangePaymentMethodSession = createStripeChangePaymentMethodSession;
exports.changeStripePaymentMethod = changeStripePaymentMethod;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var backend_services_1 = require("@src/services/backend-services");
var payment_link_helper_1 = require("./payment-link.helper");
function readStripeChangePaymentMethodDetails() {
    var queryParams = (0, payment_link_helper_1.readFitpayLinkQueryParams)(window.location.search);
    if (!queryParams.email || !queryParams.geburtstag) {
        console.error('Missing params in URL:', queryParams, window.location.search);
        return;
    }
    return {
        email: queryParams.email,
        birthday: queryParams.geburtstag,
    };
}
function buildStripeChangePaymentMethodReturnUrl(details) {
    var params = new URLSearchParams({
        email: details.email,
        geburtstag: details.birthday,
    });
    return window.location.href.split('?')[0] + '?' + params.toString();
}
function getStripePublicKey(config) {
    var _a, _b;
    if ((_a = config.stripe) === null || _a === void 0 ? void 0 : _a.forceDevKey) {
        console.warn(' ---------- USING STRIPE TEST MODE --------------');
        return 'pk_test_51QcncMRx0TziwLg9AUcsH57dOa5ifvKffUxEhEUCwrtdNHFd8LIFPV9BYuRlCC2RBE5ETsz9zxlTi9CEaOmrjZV0008QVYrOTy';
    }
    if (config.environment === 'prod' || ((_b = config.stripe) === null || _b === void 0 ? void 0 : _b.forceLiveKey)) {
        return 'pk_live_51QcncMRx0TziwLg9CaMZw1QsZIxLsXtHvEPgpejTKKJr4gpbbxJ2D42htnGse374NeWtCrMZmf4mIU7WWsUIlIBb00Xp5eHxIT';
    }
    console.warn(' ---------- USING STRIPE TEST MODE --------------');
    return 'pk_test_51QcncMRx0TziwLg9AUcsH57dOa5ifvKffUxEhEUCwrtdNHFd8LIFPV9BYuRlCC2RBE5ETsz9zxlTi9CEaOmrjZV0008QVYrOTy';
}
function createStripeChangePaymentMethodSession(config, details) {
    return __awaiter(this, void 0, void 0, function () {
        var cloudUrl, testPayment, setupIntentClientSecret, response, _a, _b, _c, e_1;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, config.environment) + '/create-change-payment-method-intent';
                    testPayment = localStorage.getItem('testPayment') === 'true';
                    setupIntentClientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret');
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                            headers: { 'Content-Type': 'application/json' },
                            method: 'POST',
                            body: JSON.stringify({
                                tenantKey: config.tenantKey,
                                fittecId: config.fittecId,
                                redirectUrl: buildStripeChangePaymentMethodReturnUrl(details),
                                changePaymentMethodDetails: details,
                                setupIntentClientSecret: setupIntentClientSecret,
                                stripeStudioMapping: (_d = config.stripe) === null || _d === void 0 ? void 0 : _d.stripeStudioMapping,
                                testPayment: testPayment,
                            }),
                        })];
                case 2:
                    response = _e.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    _b = (_a = console).error;
                    _c = ['Change payment method session error:'];
                    return [4 /*yield*/, response.json()];
                case 3:
                    _b.apply(_a, _c.concat([_e.sent()]));
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, response.json()];
                case 5: return [2 /*return*/, _e.sent()];
                case 6:
                    e_1 = _e.sent();
                    console.error('Change payment method session failed:', e_1);
                    return [2 /*return*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
function changeStripePaymentMethod(config, request) {
    return __awaiter(this, void 0, void 0, function () {
        var cloudUrl, response, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, config.environment) + '/change-payment-method';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                            headers: { 'Content-Type': 'application/json' },
                            method: 'POST',
                            body: JSON.stringify(__assign({ tenantKey: config.tenantKey, fittecId: config.fittecId }, request)),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    if (!response.ok) {
                        console.error('Change payment method error:', result);
                        return [2 /*return*/, { success: false, message: (result === null || result === void 0 ? void 0 : result.message) || 'Bezahlung fehlgeschlagen' }];
                    }
                    return [2 /*return*/, result];
                case 4:
                    e_2 = _a.sent();
                    console.error('Change payment method failed:', e_2);
                    return [2 /*return*/, { success: false, message: 'Bezahlung fehlgeschlagen' }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
